import { moment } from './time';

export const roll = (odds) => {
  const value = Math.random();
  return value <= odds;
};
export const coinFlip = (selection) => {
  if (selection === 'heads') {
    const value = Math.random();
    return value < 0.5;
  }

  const value = Math.random();
  return value >= 0.5;
};

export const includes = (files, filename) => {
  let isFound = false;
  files.forEach((f) => {
    if (f.filename === filename) {
      isFound = true;
    }
  });
  return isFound;
};

export const includesFilename = (files, filename) => {
  let isFound = false;
  files.forEach((f) => {
    if (f.filename === filename) {
      isFound = true;
    }
  });
  return isFound;
};

export const includesId = (files, id) => {
  let isFound = false;
  files.forEach((f) => {
    if (f.id === id) {
      isFound = true;
    }
  });
  return isFound;
};

export function isValidUrl(string) {
  try {
    const regex = /^(https:\/\/|www\.)[^\s/$.?#].[^\s]*$/i;
    return regex.test(string);
  } catch (e) {
    return false;
  }
}

export const parseToSearchParamsLookup = (searchParams) => {
  const lookup = {};
  for (let key of searchParams.keys()) {
    lookup[key] = searchParams.get(key);
  }
  return lookup;
};

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 */
export const getMobileOperatingSystem = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'windows-phone';
  }

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  return 'unknown';
};

export const doArraysContainSameElementValues = (arr1, arr2, config = {}) => {
  const { checkIndexOrderMatches } = config;

  if (arr1.length !== arr2.length) {
    return false;
  }

  if (checkIndexOrderMatches) {
    return arr1.every((el, i) => el === arr2[i]);
  } else {
    return arr1.every((el) => arr2.includes(el));
  }
};

export const filterDuplicates = (array) => array.filter((el, i) => array.indexOf(el) === i);

export const returnDifferentElements = (arr1, arr2) => {
  const diffEls = [];
  arr1.forEach((el) => {
    if (!arr2.includes(el)) {
      diffEls.push(el);
    }
  });
  return diffEls;
};

export const separateIntoAddedAndRemovedElements = (currentArray, prevArray) => {
  const added = returnDifferentElements(currentArray, prevArray);
  const removed = returnDifferentElements(prevArray, currentArray);
  return [added, removed];
};

export const pickOne = (availablePicks = []) => {
  const countOfAvailablePicks = availablePicks.length;
  if (countOfAvailablePicks === 0) {
    return null;
  }

  const randomSelection = Math.floor(Math.random() * countOfAvailablePicks);
  return availablePicks[randomSelection];
};

export const pluralize = (count, string, config = {}) => {
  const { prefixCount } = config;

  if (string === 'have') {
    return `${prefixCount ? `${count} ` : ''}${count === 1 ? 'has' : 'have'}`;
  }

  if (string === 'need') {
    return `${prefixCount ? `${count} ` : ''}${count === 1 ? 'needs' : 'need'}`;
  }

  return `${prefixCount ? `${count} ` : ''}${count === 1 ? string : `${string}s`}`;
};

export const isInArray = (item, array) => {
  const [key, value] = Object.entries(item)[0];
  array.forEach((el) => {
    const isItem = el[key] === value;
    if (isItem) {
      return true;
    }
  });
  return false;
};

export const getRandomIntegerInRange = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const isUndefined = (v) => v === undefined;
export const isNull = (v) => v === null;

export const isUndefinedOrNull = (v) => isUndefined(v) || isNull(v);

export const convertArrayToDisplayString = (array, limit = 0) => {
  if (limit === 1 || array.length === 1) {
    return array[0];
  } else if (limit > 0) {
    const limitedArray = array.slice(0, limit);
    const lastItem = limitedArray.splice(-1, 1);
    return `${limitedArray.join(', ')}, and ${lastItem}`;
  } else {
    const lastItem = array.splice(-1, 1);
    return `${array.join(', ')}, and ${lastItem}`;
  }
};

export const doXTimes = (x, func) => {
  for (let i = 0; i < x; i++) {
    func(i);
  }
};

export const mapXTimes = (x, func) => {
  const a = [];
  for (let i = 0; i < x; i++) {
    a.push(func(i));
  }
  return a;
};

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export const scrollToTopPageLoad = () => {
  try {
    document.addEventListener('DOMContentLoaded', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  } catch (e) {
    logError(e);
  }
};

export const scrollToTop = (timeout) => {
  try {
    setTimeout(
      () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      isNaN(timeout) || timeout === undefined ? 200 : timeout
    );
  } catch (e) {
    logError(e);
  }
};

export function isEarningsFilename(filename) {
  if (!filename) return false;
  const lowerCasedFilename = filename.toLowerCase();
  return (
    lowerCasedFilename.indexOf('earnings transcript') > -1 ||
    lowerCasedFilename.indexOf('earnings call') > -1 ||
    lowerCasedFilename.indexOf('earnings-call') > -1
  );
}

export const stripFileExtension = (file) => {
  const extension = getFileExtensionType(file);
  return file.name.split('.' + extension)[0];
};

export const getFileExtensionType = (file) => {
  const filename = file.name;
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1 || lastDotIndex === 0) {
    return '';
  }
  return filename.substring(lastDotIndex + 1).toLowerCase();
};

export function parseDateString(inputString) {
  // Define a regular expression pattern for "yyyy-mm-dd" format
  const datePattern = /\b(\d{4})-(\d{2})-(\d{2})\b/;

  // Use RegExp.exec to search for the pattern in the inputString
  const match = datePattern.exec(inputString);

  // Check if a match was found
  if (match) {
    // Extract year, month, and day from the match
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const day = parseInt(match[3], 10);

    // Check if the extracted values form a valid date
    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
      // Create a Date object
      const parsedDate = new Date(year, month - 1, day); // Month is 0-based

      // Check if the Date object is valid
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
    }
  }

  // If no valid date was found, return null
  return null;
}

export function findFirstLetterIndices(words) {
  const indices = new Array(26).fill(-1); // Array to store first index of each letter, initialized with -1
  const seen = new Set(); // Set to track letters we've already found

  // Iterate over each word
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    if (word) {
      const firstLetter = word.charAt(0).toLowerCase(); // Get the first letter of the word and ensure it's lowercase

      // Calculate the position in the alphabet (0 for 'a', 1 for 'b', etc.)
      const index = firstLetter.charCodeAt(0) - 'a'.charCodeAt(0);

      // Check if this letter has been seen before
      if (!seen.has(firstLetter)) {
        seen.add(firstLetter);
        indices[index] = i; // Set the index where this letter first appears
      }
    }
  }

  return indices;
}

export function extractDomain(url) {
  try {
    // Create a new URL object
    const parsedUrl = new URL(url);
    // Return the domain (hostname) part of the URL
    return parsedUrl.hostname.split('www.')[1] || parsedUrl.hostname;
  } catch (error) {
    // console.error('Invalid URL:', error.message);
    return null;
  }
}

export function docListSort(docs, docType) {
  if (docType === 'unknown') {
    return docs?.sort((aDoc, bDoc) => {
      const { filename: aFileName } = aDoc;
      const { filename: bFileName } = bDoc;
      if (aFileName < bFileName) {
        return -1;
      }
      if (aFileName > bFileName) {
        return 1;
      }
      return 0;
    });
  }
  return docs?.sort((aDoc, bDoc) => {
    const { filename: aFileName, doc_type } = aDoc;
    const { filename: bFileName } = bDoc;
    if (doc_type === 'Website') {
      const aDomain = extractDomain(aFileName.split(' ')[0]);
      const bDomain = extractDomain(bFileName.split(' ')[0]);
      if (aDomain < bDomain) {
        return -1;
      }
      if (aDomain > bDomain) {
        return 1;
      }
      return 0;
    } else {
      const aDate = parseDateString(aFileName);
      const bDate = parseDateString(bFileName);
      return moment(bDate).valueOf() - moment(aDate).valueOf();
    }
  });
}

export const calcSuggestedMinMax = (data, defaultValue) => {
  if (!data) {
    return {
      min: defaultValue * -1,
      max: defaultValue,
    };
  }

  try {
    let min = 0;
    let max = 0;
    const { datasets, datapoints } = data;

    if (datasets) {
      datasets.forEach((d) => {
        const { data } = d;
        data.forEach((point) => {
          const { y } = point;
          if (y < min) {
            min = y;
          }
          if (y > max) {
            max = y;
          }
        });
      });
    } else {
      datapoints.forEach((point) => {
        const { y } = point;
        if (y < min) {
          min = y;
        }
        if (y > max) {
          max = y;
        }
      });
    }

    const absMax = Math.max(Math.abs(min), max);
    const padded = Math.min(1, 1.1 * absMax);
    return {
      min: padded * -1,
      max: padded,
    };
  } catch (e) {
    return {
      min: defaultValue * -1,
      max: defaultValue,
    };
  }
};

export const logError = (d, p) => {
  console.log('--ERROR--', d, p);
  return null;
};
export const logNetRequest = (n, s, d, v) => {
  if (v) {
    console.log(n, s, d, v);
  } else if (d) {
    console.log(n, s, d);
  } else {
    console.log(n, s);
  }
};
export const logger = (n, s, d) => {
  console.log(n, s, d);
};
export const logFormSubmit = (n, s, d) => {
  console.log(n, s, d);
};

export const uniqueIdGenerator = () => {
  const generatedIds = new Set();

  function generateId() {
    // Define the characters to be used in the ID
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = 8; // Length of the unique ID
    let id;

    // Generate a unique ID
    do {
      id = '';
      for (let i = 0; i < length; i++) {
        id += characters.charAt(Math.floor(Math.random() * characters.length));
      }
    } while (generatedIds.has(id)); // Ensure the ID is unique

    // Store the generated ID
    generatedIds.add(id);
    return id;
  }

  return generateId;
};

export function removeElementFromArray(elementToRemove, array) {
  const index = array.findIndex((element) => element === elementToRemove);
  if (index !== -1) {
    array.splice(index, 1);
  }
  return array;
}

export function extractIntegerAfterHash(inputString) {
  if (typeof inputString === 'string') {
    const match = inputString.match(/#(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  } else {
    logger('invalid input string', inputString);
    return null;
  }
}

export function extractDateFromString(inputString) {
  const dateRegex =
    /\b(\d{4}[-\/.]\d{1,2}[-\/.]\d{1,2}|\d{1,2}[-\/.]\d{1,2}[-\/.]\d{4}|\d{1,2}[-\/.]\d{1,2}[-\/.]\d{2}|\d{1,2} (?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{4}|\d{1,2} (?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{2}|\d{4} (?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{1,2})\b/i;
  const dateMatch = inputString.match(dateRegex);
  if (!dateMatch) {
    return null;
  }
  return dateMatch[0];
}

export function truncateStringWithDate(inputString, maxLength) {
  if (!inputString) return inputString;

  if (inputString.length <= maxLength) {
    return inputString;
  }

  const dateMatch = extractDateFromString(inputString);
  if (dateMatch === null) {
    return inputString.length > maxLength ? inputString.slice(0, maxLength) + '...' : inputString;
  }

  const truncateLength = inputString.length - maxLength;
  const dateLength = dateMatch[0].length;
  const adjustedTruncateLength = Math.max(truncateLength, dateLength);

  const datePosition = inputString.indexOf(dateMatch);
  const firstPart = inputString.slice(0, datePosition - adjustedTruncateLength - '...'.length);
  return `${firstPart.trim()}...${dateMatch}`;
}

export async function asyncForEach(array, callback) {
  for (let i = 0; i < array.length; i++) {
    await callback(array[i], i, array);
  }
}

export function levenshteinDistance(a, b) {
  const matrix = [];

  // Increment along the first column of each row
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }

  // Increment each column in the first row
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  // Fill in the rest of the matrix
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1, // substitution
          matrix[i][j - 1] + 1, // insertion
          matrix[i - 1][j] + 1 // deletion
        );
      }
    }
  }

  return matrix[b.length][a.length];
}

export function removeWhitespace(str) {
  if (!str) return '';
  return str.replace(/\s+/g, '');
}

export function findBestFileNameMatch(inputString, docs) {
  if (typeof inputString !== 'string') return null;
  if (!docs) return null;

  let bestMatch = null;
  let lowestDistance = Infinity;

  for (let doc of docs) {
    const str = doc.filename;
    if (str) {
      const distance = levenshteinDistance(inputString, str);
      if (distance < lowestDistance) {
        lowestDistance = distance;
        bestMatch = doc;
      }
    }
  }

  return bestMatch;
}

export function flatten(arr) {
  return arr.reduce((acc, val) => (Array.isArray(val) ? acc.concat(flatten(val)) : acc.concat(val)), []);
}

export function filterDuplicateDocuments(documents) {
  const uniqueDocuments = [];
  const ids = new Set();

  documents.forEach((doc) => {
    if (!ids.has(doc.id)) {
      ids.add(doc.id);
      uniqueDocuments.push(doc);
    }
  });

  return uniqueDocuments;
}

export function filterDuplicateCompanies(companies) {
  const tickerIds = {};
  const companyTagIds = {};
  const uniqueCompanies = [];

  companies.forEach((company) => {
    if (company.company_id) {
      if (!tickerIds[company.company_id]) {
        tickerIds[company.company_id] = true;
        uniqueCompanies.push(company);
      }
    }
    if (company.doc_tag_id) {
      if (!companyTagIds[company.doc_tag_id]) {
        companyTagIds[company.doc_tag_id] = true;
        uniqueCompanies.push(company);
      }
    }
  });

  return uniqueCompanies;
}
export const copyObject = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};
export function isObject(item) {
  try {
    return typeof item === 'object' && item !== null;
  } catch (e) {
    return false;
  }
}
export function isValidJsonObject(str) {
  if (typeof str === 'object') return true;
  try {
    const obj = JSON.parse(str);
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
  } catch (e) {
    return false;
  }
}

export function getKey(item) {
  return Object.keys(item)[0];
}
export function getValue(item) {
  return Object.values(item)[0];
}
export function convertToOnOff(value) {
  if (value === true) {
    return 'on';
  } else if (value === false) {
    return 'off';
  } else {
    return value;
  }
}

export function convertMonthYearStringToLastDate(str) {
  if (!str) return undefined;
  const [monStr, yearStr] = str.split(' ');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthIdx = monthNames.indexOf(monStr);
  const year = parseInt(yearStr, 10);
  if (monthIdx === -1 || isNaN(year)) return undefined;
  // The 0th day of the next month is the last day of the given month
  const date = new Date(year, monthIdx + 1, 0);
  // Return as yyyy-mm-dd
  return date.toISOString().slice(0, 10);
}

// ---- Functions migrated from full-lib/nvstr-utils ----

export function toCapitalCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export const truncate = (str, maxLength, suffix = '...') => {
  if (!str) return '';
  if (!(maxLength > 0)) {
    throw new Error(`Max length for truncate must be greater than 0, received: ${maxLength}`);
  }
  const suffixLength = suffix.length;
  if (str.length <= maxLength - suffixLength) {
    return str;
  }
  const slicedStr = str.slice(0, maxLength - suffixLength);
  if (slicedStr[slicedStr.length - 1] === ' ') {
    return slicedStr.slice(0, slicedStr.length - 1) + suffix;
  } else {
    return slicedStr + suffix;
  }
};

export function getContrastTheme(hex, colors) {
  if (!/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    return null;
  }

  let r;
  let g;
  let b;
  if (hex.length == 4) {
    r = parseInt('0x' + hex[1] + hex[1], 16);
    g = parseInt('0x' + hex[2] + hex[2], 16);
    b = parseInt('0x' + hex[3] + hex[3], 16);
  } else {
    r = parseInt('0x' + hex[1] + hex[2], 16);
    g = parseInt('0x' + hex[3] + hex[4], 16);
    b = parseInt('0x' + hex[5] + hex[6], 16);
  }

  let getAdjustedValue = (value) => {
    value /= 255;
    return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
  };

  r = getAdjustedValue(r);
  g = getAdjustedValue(g);
  b = getAdjustedValue(b);

  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance > 0.179 ? colors.light : colors.dark;
}

export const isMobileBrowser = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const isSafari = () => {
  return navigator.userAgent.indexOf('Safari') !== -1;
};

export const hexToRgbA = (hex, a) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${a})`;
  }
  return false;
};

export const convertHexToRGBA = (hex, a) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${a})`;
  }
  return false;
};

export const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

const _componentToHex = (c) => {
  const hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
};

export const rgbToHex = (r, g, b) => {
  return '#' + _componentToHex(r) + _componentToHex(g) + _componentToHex(b);
};

export function toTitleCase(string) {
  return string
    .split(' ')
    .map((word) => word[0].toUpperCase() + word.substr(1).toLowerCase())
    .join(' ');
}

export function replaceAll(inputStr, findChar, replaceChar) {
  let result = '';

  for (let i = 0; i < inputStr.length; i++) {
    if (inputStr[i] === findChar) {
      result += replaceChar;
    } else {
      result += inputStr[i];
    }
  }

  return result;
}

export const pickItemWithProbability = (items, probabilityLookup = {}) => {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  const lessonsWithProbabilities = Object.keys(probabilityLookup);
  const itemsNeedingProbabilities = items.filter((it) => lessonsWithProbabilities.indexOf(it.toString()) < 0);
  const probabilitiesSelectable = Object.entries(probabilityLookup).filter(
    (g) => items.indexOf(parseInt(g[0], 10)) >= 0
  );
  const fixedProbabilityTotal = probabilitiesSelectable.reduce((accumulator, a) => accumulator + a[1], 0);
  if (fixedProbabilityTotal >= 1) {
    console.error('fixed probability is greater than 1, cannot select');
    return null;
  }
  const remainingProbabilityTotal = 1 - fixedProbabilityTotal;
  const selectionValue = Math.random();
  const finalSelectionProbabilities = [];
  let accumulator = 0;
  probabilitiesSelectable.forEach((l) => {
    const prob = l[1];
    accumulator += prob;
    const id = parseInt(l[0], 10);
    finalSelectionProbabilities.push([id, accumulator]);
  });
  const evenDistProb = remainingProbabilityTotal / itemsNeedingProbabilities.length;
  itemsNeedingProbabilities.forEach((l) => {
    accumulator += evenDistProb;
    finalSelectionProbabilities.push([l, accumulator]);
  });
  let selection = null;
  for (let i = 0; i < finalSelectionProbabilities.length; i++) {
    let item = finalSelectionProbabilities[i];
    if (selection === null && selectionValue <= item[1]) {
      selection = parseInt(item[0], 10);
    }
  }
  return selection;
};
